<template>
  <div class="w-1/4 full">
    <div class="flex md:items-center xs:items-start justify-end gap-2 py-1">
      <input
        class="border w-14 h-8 border-brand-gray-600 rounded-sm focus:ring-primary focus-within:outline-none text-center"
        type="inputType"
        v-model="modalValue"
        :data-maska="mask"
        v-maska
        @change="$emit('onChange', $event)"
      />
      <span> {{ $t('of') }} {{ paginatorConfig.pageCount }} </span>
    </div>
  </div>
</template>

<script setup>
import { vMaska } from 'maska'

const props = defineProps({
  mask: String,
  inputType: {
    type: String,
    default: 'numbner'
  },
  paginatorConfig: {
    type: Object,
    default: () => {}
  }
})
const modalValue = defineModel()
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
